import { Fragment, useCallback, useMemo, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { getItemsFromObject } from "../../../../services/array/transformObject";
import { useTranslation } from "react-i18next";
import { languages } from "../../../../i18n/i18n.constants";
import { mapLangToCountryCode } from "../../../../services/format/countryAndLangCodes";

const LanguageDropDown = () => {
    const languageList = useMemo(() => getItemsFromObject(languages), []);
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language ?? languageList[0]);

    const changeLanguageHandler = useCallback(
        (language: string) => {
            setLanguage(language);
            i18n.changeLanguage(language);
        },
        [i18n]
    );

    return (
        <>
            <NavDropdown
                title={
                    <>
                        <span className={`navbar-icon fi fi-${mapLangToCountryCode(language)}`}></span>
                        {language}
                    </>
                }
                className="language-dropdown"
                id="language-dropdown"
            >
                {languageList.map((item, index) => (
                    <Fragment key={`language-${item}`}>
                        <NavDropdown.Item onClick={() => changeLanguageHandler(item)}>
                            <>
                                <span className={`navbar-icon fi fi-${mapLangToCountryCode(item)}`}></span>
                                {item}
                            </>
                        </NavDropdown.Item>
                        {index + 1 !== languageList.length && <NavDropdown.Divider />}
                    </Fragment>
                ))}
            </NavDropdown>
        </>
    );
};

export default LanguageDropDown;
